// https://github.com/Richienb/url-exist/blob/fetch/index.js
export default async function urlExist(url: string, { method = 'HEAD', timeout = 10_000 } = {}): Promise<boolean> {
    if (typeof url !== 'string') {
        throw new TypeError(`Expected url to be a string, got ${typeof url}`);
    }

    // Check if url is valid
    new URL(url);

    try {
        const controller = new AbortController();
        const signal = controller.signal;

        const timeoutPromise = new Promise<void>((_, reject) => {
            setTimeout(() => {
                controller.abort();
                reject(new Error('Request timeout'));
            }, timeout);
        });

        const fetchPromise = fetch(url, { method, signal });

        const response = await Promise.race([fetchPromise, timeoutPromise]);

        if (response instanceof Response) {
            return response.status < 400 || response.status >= 500;
        } else {
            return false;
        }
    } catch {
        return false;
    }
}
